import styled from 'styled-components';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { GridRowClassNameParams } from '@mui/x-data-grid/models/params';
import { Collapse, Grid, ListItemIcon, Paper, Typography } from '@mui/material';
import { extraColor } from '@styles/muiTheme';
import { StyledDialogContent } from '@styles/ModalStyles';

export const SectionLabel = styled.div<{ mb?: string }>`
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: ${({ mb }) => mb || '10px'};
`;

export const excludedRowClassName = (params: GridRowClassNameParams): string => (params.row.isExcluded ? 'red-bg' : '');

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .MuiFormControl-root {
    min-width: 160px;
    max-width: 220px;
    width: 100%;
  }
`;

export const RoleModalSectionHeader = styled(Typography)`
  max-width: calc(100% - 100px);
  margin-top: -18px;
  height: 60px;
  display: flex;
  align-items: center;
`;

export const RoleDialogContent = styled(StyledDialogContent)`
  && {
    background: ${extraColor.palette.grey.light };
    padding: 0 24px;

    .MuiDataGrid-cellContent {
      white-space: pre;
    }
  }
`;

export const DialogSection = styled(Paper)`
  padding: 20px;
  height: 100%;
  box-shadow: 0 0 15px ${extraColor.palette.grey.main };
  position: relative;
`;

export const GridContainer = styled(Grid)`
  height: calc(100% - 30px);
  padding: 24px 0 12px 0;
`;

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ListWrapper = styled.div`
  background: ${extraColor.palette.blue.light };
  border: 1px solid ${extraColor.palette.blue.main };
  overflow: auto;
  height: 100%;
  flex: 1;
`;

export const Scroller = styled.div`
  height: 100%;
  overflow: auto;
`;

export const Content = styled(Collapse)`
  .MuiList-root {
    padding: 0 0 0 20px;
  }
`;

export const IconWrapper = styled(ListItemIcon)`
  min-width: 25px;
  height: 40px;
  display: flex;
  align-items: center;

  .MuiCheckbox-root {
    right: -4px;
    position: relative;
  }

  .MuiButtonBase-root {
    padding: 8px;
  }
`;

export const ExpMore = styled(ExpandMore)`
  transform: rotateZ(-90deg);
`;

export const ExpLess = styled(ExpandLess)`
  transform: rotateZ(135deg);
`;